import React from 'react';
import BoxBody from 'components/BoxBody';
import Text from 'components/Text';
import Row from 'components/Row';
import Button from 'components/ButtonDeprecated';
import MediaObject from 'components/MediaObject';
import CoachingConstants from 'coaching/CoachingConstants';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';

export default function CoachingNoUpcomingSessionsCard() {
  const noSessionsText = (
    <Text size="small" data-test="no-upcoming-sessions-text">
      No upcoming sessions
    </Text>
  );

  const scheduleButton = (
    <Button
      size="xsmall"
      data-test="schedule-session-empty-state-button"
      eventKey="coaching.coaching_home_dashboard.schedule_session.click"
      to={CoachingConstants.COACHING_HELP_ROUTE}
      target="_blank">
      Request sessions
    </Button>
  );

  return (
    <BoxBody size="small">
      {userAgent.isDesktop() ? (
        <MediaObject center figure="right">
          {noSessionsText}
          {scheduleButton}
        </MediaObject>
      ) : (
        <React.Fragment>
          <Row size="small">{noSessionsText}</Row>
          {scheduleButton}
        </React.Fragment>
      )}
    </BoxBody>
  );
}
